import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { QuestionService } from 'src/app/_services/question.service';
import { AdminService } from './../../../_services/admin.service';

@Component({
  selector: 'app-replace-template',
  templateUrl: './replace-template.component.html',
  styleUrls: ['./replace-template.component.css']
})
export class ReplaceTemplateComponent implements OnInit {
  xQuestionTemplate:any=undefined
  xQuestionTemplateId:number = undefined
  isSaving=false
  templateList=[]
  errorSaving=false


  myForm:FormGroup

  constructor(private activatedRoute:ActivatedRoute, private adminService:AdminService, private router:Router,private questionService:QuestionService) { }
  get f() {
    return this.myForm.controls
  }
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      p=>{
        this.xQuestionTemplateId= p["server_task_template_id"]
        this.questionService.getQuestionTemplateById(this.xQuestionTemplateId).subscribe(
          {
  next:(data:ResultData)=>{
    this.xQuestionTemplate = data.rs.data
  },error:(err)=>{

  }
 }


        )

      }

    )
    this.initForm()
  }
  on_submit(){
    this.isSaving=true
    let dd=this.formatData(this.myForm.value.body)
    this.adminService.replaceQuestionTemplate(dd).subscribe(
      val=>{
        this.isSaving=false

        if(val['server_task_template_id']==0){

          this.errorSaving=true
        }
        else{
          this.router.navigate(['/task/template/show',val['server_task_template_id']])
        }

      }
    )

  }
  formatData(body:string){
    let data = new URLSearchParams();
    data.set('nCode', body);
    data.set('id',this.xQuestionTemplateId.toString())


    return data.toString()
  }
  initForm(){
    this.myForm= new FormGroup({body: new FormControl("", [Validators.required,Validators.minLength(4)])})

   }






}
